
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../mixins";
import { StandardOption } from "./StandardOption";

@Component
export default class MultiOrderableSelectableMixin extends Mixins(ModelEditableMixin) {
  @Prop()
  shouldShowSelectionCount: boolean;

  @Prop()
  selectionMaxCount: number;

  @Prop()
  additionMaxCount: number;

  data(): any {
    return {
      selectableOptions: [],
    };
  }
  selectableOptions: StandardOption<any>[];

  get isOverSelectionMaxCount(): boolean {
    return this.editingSource && this.editingSource.length > this.selectionMaxCount;
  }

  get selectedOptionsWarning(): string {
    return this.isOverSelectionMaxCount
      ? "件数が多すぎます。" + this.selectionMaxCount + "件以下にしてください。"
      : "";
  }

  get selectedOptionsCount(): number {
    return this.editingSource ? this.editingSource.length : 0;
  }

  get optionsCount(): number {
    return this.selectableOptions ? this.selectableOptions.length : 0;
  }

  onFilteredOptionsChanged(filteredOptions: StandardOption<any>[]): void {
    this.selectableOptions = filteredOptions;
  }
}
